// @flow

import React from 'react';
import { InputV2, InputConsumer, PasswordInput } from '@catalytic/catalytic-ui';
import useFieldContext from './FieldContext';

type Props = {
  value: any
};

const ConfidentialView = ({ value }: Props) => {
  const fieldContext = useFieldContext();
  const {
    className,
    description,
    disabled,
    displayErrors,
    displayName,
    embedded,
    example,
    hasValidation,
    id,
    name,
    onBlur,
    onChange,
    required,
    type
  } = fieldContext || {};
  return (
    <InputV2
      className={className}
      description={description}
      disabled={disabled}
      displayErrors={displayErrors}
      example={example}
      hasValidation={hasValidation}
      id={id}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      readOnly
      title={displayName}
      type={type}
      value={value}
    >
      <InputConsumer>
        {props => (
          <PasswordInput
            defaultValue={value}
            embedded={embedded}
            id={id}
            name={name}
            required={required}
            {...props}
          />
        )}
      </InputConsumer>
    </InputV2>
  );
};
ConfidentialView.displayName = 'ConfidentialView';
ConfidentialView.defaultProps = {
  value: 'CONFIDENTIAL'
};

export default ConfidentialView;
